export default __webpack_public_path__ + "static/media/hero-img.f5c40316.svg";